import axios from 'axios'
import Vue from 'vue'

const reTabs = RegExp('^`(.*)`')
const reRelativePicture = RegExp(/!.*\(((?!http).*(\.png|\.jpeg|\.jpg|\.gif))\)/gm)
const waitSetNull = 1000

const getTabData=async function(data,contextRoute, tab){
  try{
    const response = await axios.get(
      `https://raw.githubusercontent.com/djuliZP/djuli-documentation/main/${contextRoute}/${tab}.md`
    )
    Vue.set(data,tab,prepareMD(response.data,contextRoute))
  }catch{
    Vue.set(data,tab,'')
  }
}

const prepareMD=function(rawString,contextRoute){
  let relativePicturesMatch=reRelativePicture.exec(rawString)
  while(relativePicturesMatch!==null){
    rawString=rawString.replace(relativePicturesMatch[1],`https://raw.githubusercontent.com/djuliZP/djuli-documentation/main/${contextRoute}/${relativePicturesMatch[1]}`)
    relativePicturesMatch=reRelativePicture.exec(rawString)
  }
  return rawString
}

const typeStateContext = {
  CLEAR: 0,
  OBJECT: 1,
  NOT_FOUND: 2
}

const state = {
  typeCntxHelp: typeStateContext.CLEAR,
  dataCntxHelp: {},
  tabsCntxHelp:{},
  visibleLearningCntxHelp:false,
  widthLearningCntxHelp:'450px',
  holdLearningCntxHelp:false,
  routeCntxHelp:'',
  timerSetNullCntxHelp:null,
  btnHoldSetCntxHelp:false
}

const getters = {
  getRouteCntxHelp:state=>state.routeCntxHelp,
  getDataCntxlHelp: state => state.dataCntxHelp,
  getTypeCntxlHelp: state => state.typeCntxHelp,
  isVisibleLearningCntxlHelp:state=>state.visibleLearningCntxHelp,
  getTabsCntxHelp:state=>state.tabsCntxHelp,
  getWidthLearningCntxHelp:state=>state.widthLearningCntxHelp,
  isHoldLearningCntxHelp:state=>state.holdLearningCntxHelp,
  isBtnHoldSetCntxHelp:state=>state.btnHoldSetCntxHelp,
}

const actions = {
  async setContextualHelp ({ commit,state }, contextRoute) {
    // On any change cancel the timer
    if(state.timerSetNullCntxHelp !== null){
      clearTimeout(state.timerSetNullCntxHelp)
      commit('SET_TIMER_NULL_CNTX_HELP', null)
    }
    if(state.holdLearningCntxHelp){
      return
    }
    if (contextRoute === null) {
      // Does not clear the context help directly, set a timer
      commit('SET_TIMER_NULL_CNTX_HELP', setTimeout(() => {
          commit('SET_TYPE_CNTX_HELP', typeStateContext.CLEAR)
          commit('RESET_CNTX_HELP')
          commit('SET_TIMER_NULL_CNTX_HELP', null)
        }, waitSetNull)
      )
      return
    }
    commit('SET_ROUTE_CNTX_HELP', contextRoute)
    try {
      const response = await axios.get(
        `https://raw.githubusercontent.com/djuliZP/djuli-documentation/main/${contextRoute}/main.md`
      )
      if(typeof(response.data)==='undefined' || response.data===''){
        commit('SET_TYPE_CNTX_HELP', typeStateContext.NOT_FOUND)
        commit('RESET_CNTX_HELP')
        return
      }
      const mainData = prepareMD(response.data,contextRoute)
      const matchTabsData=reTabs.exec(mainData)
      const newTabs=['Main']
      const newDataObtj={'Main':mainData}
      if(matchTabsData!==null){
        const extraTabs=matchTabsData[1].split(',').filter(tab=> tab!=='Main') //Filter the main, so it does not has any issue with the main tab
        newTabs.push(...extraTabs)
        extraTabs.forEach(tab=>getTabData(newDataObtj,contextRoute,tab))
        newDataObtj.Main=mainData.replace(matchTabsData[0],'')
      }
      commit('SET_DATA_CNTX_HELP', newDataObtj)
      commit('SET_TABS_CNTX_HELP', newTabs)
      commit('SET_TYPE_CNTX_HELP', typeStateContext.OBJECT)
    } catch {
      commit('SET_TYPE_CNTX_HELP', typeStateContext.NOT_FOUND)
      commit('RESET_CNTX_HELP')
    }
  },
  setContextOnHover({ state, dispatch }, contextRoute){
    if(state.visibleLearningCntxHelp){
      dispatch('setContextualHelp',contextRoute)
    }
  },
  setContextFixElement({ state,commit, dispatch },contextRoute){
    if(!state.btnHoldSetCntxHelp){
      return
    }
    if(state.visibleLearningCntxHelp){
      if(state.routeCntxHelp === contextRoute){
        commit('SET_HOLD_LEARNING_CNTX_HELP', !state.holdLearningCntxHelp)
        return
      }
      commit('SET_HOLD_LEARNING_CNTX_HELP', false)
      dispatch('setContextualHelp',contextRoute)
      commit('SET_HOLD_LEARNING_CNTX_HELP', true)
    }
  },
  setVisibleLearningCntxlHelp({ commit,dispatch  }, newValue){
    commit('SET_VISIBLE_LEARNING_CNTX_HELP', newValue)
    if(!newValue){
      dispatch('setContextualHelp',null)
    }
  },
  setWidthLearningCntxlHelp({ commit }, newValue){
    commit('SET_WIDTH_LEARNING_CNTX_HELP', newValue)
  },
  setHoldLearningCntxHelp({ commit,state }, newValue){
    if(!state.visibleLearningCntxHelp){ //If the learning mode is not visible it should not do anything
      return
    }
    commit('SET_HOLD_LEARNING_CNTX_HELP', newValue)
  },
  resetTimerSetNullCntxHelp({ commit,state }){
    if(state.timerSetNullCntxHelp !== null){
      clearTimeout(state.timerSetNullCntxHelp)
      commit('SET_TIMER_NULL_CNTX_HELP', null)
    }
  },
  setBtnHoldSetCntxHelp({ commit }, newBool){
    commit('SET_BTN_HOLD_CNTX_HELP', newBool)
  }
}

const mutations = {
  RESET_CNTX_HELP:(state)=> {
    state.dataCntxHelp = {}
    state.tabsCntxHelp=[]
  },
  SET_DATA_CNTX_HELP: (state, dataCntxHelp) => (state.dataCntxHelp = dataCntxHelp),
  SET_TABS_CNTX_HELP: (state, newVal) => (state.tabsCntxHelp = newVal),
  SET_ROUTE_CNTX_HELP: (state, newVal) => (state.routeCntxHelp = newVal),
  SET_TYPE_CNTX_HELP: (state, typeCntxHelp) => (state.typeCntxHelp = typeCntxHelp),
  SET_VISIBLE_LEARNING_CNTX_HELP: (state, newValue) => (state.visibleLearningCntxHelp = newValue),
  SET_WIDTH_LEARNING_CNTX_HELP: (state, newValue) => (state.widthLearningCntxHelp = newValue),
  SET_HOLD_LEARNING_CNTX_HELP: (state, newValue) => (state.holdLearningCntxHelp = newValue),
  SET_TIMER_NULL_CNTX_HELP: (state, newValue) => (state.timerSetNullCntxHelp = newValue),
  SET_BTN_HOLD_CNTX_HELP: (state, newValue) => (state.btnHoldSetCntxHelp = newValue),
}

export default {
  state,
  getters,
  actions,
  mutations
}
